import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineLite, TweenLite} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";


export class BuffaloPickBonus extends PIXI.Container implements StageLayer {

    constructor() {
        super();

        this.addEventListeners();
    }

    private addEventListeners():void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => {}); // this.onBeforeSpinStart()

        // TODO: Replaced by prepare
        // EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        // EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    private dispatchStartBonus(index:number = 1) {
        //debugger;
        //EventHandler.dispatchEvent(new GameEvent(BalanceEvent.PICK_AND_CLICK, index));
    }

    getStartAnimation(prepareToEnterModeCallback:() => void, completeCallback:() => void):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(() => this.dispatchStartBonus());

        return tl;
    }

    getEndAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(() => this.dispatchStartBonus());

        tl.add(new TweenLite(this, 0.2, {alpha:0}));
        return tl;
    }

    public prepare(data:ParsedServerData):void {
        //this._numberText.text = "" + data.freespinsLeft;
    }

}